/**
 * Errors opt out of Sentry by carrying `sentryIgnore: true`. Read structurally like the fingerprint
 * next door, so observability needn't depend on the packages owning the error classes.
 */
export function isUnreportedError(error: unknown): boolean {
  return error instanceof Error && (error as { sentryIgnore?: unknown }).sentryIgnore === true;
}
